import { WITHDRAW_CONFIRM } from '@selfon/domain/browser';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api';
import { useAuth } from '../auth/AuthContext';
import { Alert, Dialog, Field, PageHeader } from '../components/ui';

/** 내 계정: 탈퇴. 원장님은 센터 자료가 있어 고객센터로 안내한다. */
export function Account() {
  const { me, deleteLogin } = useAuth();
  const [open, setOpen] = useState(false);
  const [confirm, setConfirm] = useState('');
  const director = me?.role === 'CENTER_DIRECTOR';
  return (
    <div className="stack">
      <PageHeader title="내 계정" sub={me?.name ?? undefined} />
      <section className="card stack" aria-labelledby="withdraw-h">
        <h2 id="withdraw-h">회원 탈퇴</h2>
        {director ? (
          <>
            <p className="muted">원장님 계정에는 센터 자료가 연결되어 있어 바로 탈퇴할 수 없습니다.</p>
            <p>먼저 <Link to="/settings">센터 설정</Link>에서 자료를 내려받고, 유료서비스를 해지한 뒤 <Link to="/support">고객센터</Link>로 센터 종료를 요청해 주세요.</p>
          </>
        ) : (
          <>
            <ul className="small">
              <li>이름과 연락처를 지우고 로그인할 수 없게 됩니다. 되돌릴 수 없습니다.</li>
              <li>센터가 작성한 수업·과제 기록은 센터의 자료로 남습니다.</li>
              {me?.role === 'GUARDIAN' && <li>자녀와 센터의 연결이 끊기고 등록한 자녀 정보가 지워집니다.</li>}
              {me?.role === 'THERAPIST' && <li>소속 센터에서 비활성 상태로 바뀝니다.</li>}
            </ul>
            <div><button type="button" className="btn btn-outline" onClick={() => { setConfirm(''); setOpen(true); }}>회원 탈퇴</button></div>
          </>
        )}
      </section>

      <Dialog danger title="회원 탈퇴" open={open} onClose={() => setOpen(false)} submitLabel="탈퇴" keepOpen
        onSubmit={async () => {
          await api.withdraw(confirm);
          await deleteLogin();
        }}>
        <Alert kind="info">되돌릴 수 없습니다.</Alert>
        <Field id="wd-confirm" label={`확인을 위해 "${WITHDRAW_CONFIRM}" 를 입력하세요`}>
          <input id="wd-confirm" required autoComplete="off" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </Field>
      </Dialog>
    </div>
  );
}
